import { observer } from 'mobx-react-lite'
import { usePendingJobId } from '@/features/jobs/details/job-navigation-hooks'
import { StatusGlyph } from '@/features/jobs/components/StatusGlyph'
import { type JobItemViewModel } from '@/features/jobs/details/components/JobList/JobItem/JobItemViewModel'
import { JobSidebarItem } from '@/features/jobs/details/components/JobSidebarItem'

export interface JobSidebarItemContainerProps {
  vm: JobItemViewModel
}

export const JobSidebarItemContainer = observer(
  function JobSidebarItemContainer({ vm }: JobSidebarItemContainerProps) {
    const [glyph, tone] = vm.statusGlyph
    const pendingJobId = usePendingJobId()

    return (
      <JobSidebarItem
        to={vm.href}
        isActive={pendingJobId ? pendingJobId === vm.job.id : vm.isActive}
        jobName={vm.jobName}
        status={<StatusGlyph glyph={glyph} tone={tone} />}
        client={vm.clientDisplayName}
        isOverdue={vm.isOverdue}
        unreadCount={vm.unreadCount}
        dueLabel={vm.dueLabel}
        subtitle={vm.subtitle}
      />
    )
  },
)
